/** Pages about bookings and trips have nothing to do with the selected vessel: the vessel bar is left out there. */
const BOOKING_PAGES = /^\/(dashboard|book|calendar|trips|agency|help)(\/|$)/;

export function showsVesselBar(pathname: string): boolean {
  return !BOOKING_PAGES.test(pathname);
}
